import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import AnalyticsStore from '~/glm/models/analytics-store';
import Icon from '@xo-union/tk-component-icons';
import { Button } from '@xo-union/tk-component-buttons';
import styles from './guest-search-field.scss';

class GuestSearchField extends Component {
  state = {
    trackingSent: false,
  };

  static propTypes = {
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
    analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  };

  onFilterChange = e => {
    const { gdsUiState, analyticsStore } = this.props;
    const searchValue = e.target.value;
    if (searchValue && !this.state.trackingSent) {
      this.setState({ trackingSent: true });
      analyticsStore.track('Dashboard Interaction', {
        action: 'search initiated',
      });
    }
    gdsUiState.setFilter(searchValue);
  };

  handleOnBlur = () => {
    this.setState({ trackingSent: false });
  };

  render() {
    const { gdsUiState } = this.props;

    return (
      <Fragment>
        <input
          onBlur={this.handleOnBlur}
          value={gdsUiState.filter}
          placeholder="Find Guests"
          onChange={this.onFilterChange}
          className={styles.searchBox}
          data-testid="find-guests-input"
        />
        <Button className={styles.searchButton}>
          <Icon name="search" size="md" className={styles.searchIcon} />
        </Button>
      </Fragment>
    );
  }
}

// Override displayName for testing purposes
GuestSearchField.displayName = 'GuestSearchField';

export default inject('gdsUiState', 'analyticsStore')(observer(GuestSearchField));
